module.exports = __webpack_public_path__ + "static/media/search-listing-icon-inactive.3f994f49.svg";